export default "__VITE_ASSET__329853e5__"